/* NR · E4 «Rostros de la Nación» — selector interactivo del crew (patrón tabs, cero dependencias).
   Clic / teclado en un anillo del crew → intercambia el escenario grande (foto/historia) del rostro.
   Progresivo: sin JS se muestra el «rostro del momento» (el escenario sin [hidden]) y los anillos
   quedan como retratos. El JS solo mejora; nunca es requisito para ver la sección.

   Accesibilidad: tablist con roving tabindex + flechas ←/→, Home/End (WAI-ARIA Tabs).
   Rendimiento: al activar un escenario con video, reproduce ese y pausa los demás. */
(function () {
  'use strict';

  function initSection(root) {
    if (root.__nrros) return;
    root.__nrros = true;

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-nrros-tab]'));
    var stages = Array.prototype.slice.call(root.querySelectorAll('[data-nrros-stage]'));
    if (tabs.length < 2 || !stages.length) return; // 0–1 rostros = nada que intercambiar

    function activate(index) {
      tabs.forEach(function (tab) {
        var i = tab.getAttribute('data-nrros-tab');
        var on = i === String(index);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        tab.classList.toggle('is-active', on);
      });
      stages.forEach(function (stage) {
        var on = stage.getAttribute('data-nrros-stage') === String(index);
        if (on) {
          stage.removeAttribute('hidden');
          // Pulido: la foto que aparece hace un fade/scale corto = refuerza que cambió (feedback táctil).
          var media = stage.querySelector('.nrros__media');
          if (media) { media.classList.remove('nrros__media--in'); void media.offsetWidth; media.classList.add('nrros__media--in'); }
        } else {
          stage.setAttribute('hidden', '');
        }
        var vid = stage.querySelector('video');
        if (vid) {
          if (on) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
          else { try { vid.pause(); } catch (e) {} }
        }
      });
    }

    tabs.forEach(function (tab, pos) {
      tab.addEventListener('click', function () {
        activate(tab.getAttribute('data-nrros-tab'));
      });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        switch (e.key) {
          case 'ArrowRight': case 'ArrowDown': next = (pos + 1) % tabs.length; break;
          case 'ArrowLeft':  case 'ArrowUp':   next = (pos - 1 + tabs.length) % tabs.length; break;
          case 'Home': next = 0; break;
          case 'End': next = tabs.length - 1; break;
          default: return;
        }
        e.preventDefault();
        var target = tabs[next];
        target.focus();
        activate(target.getAttribute('data-nrros-tab'));
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-nrros]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Editor de temas: re-inicializa al recargar/seleccionar la sección.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-nrros]');
    if (el) { el.__nrros = false; initSection(el); }
  });
})();
